import { render, staticRenderFns } from "./MaterialBom.vue?vue&type=template&id=52dd15bb&scoped=true&"
import script from "./MaterialBom.vue?vue&type=script&lang=js&"
export * from "./MaterialBom.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBom.vue?vue&type=style&index=0&id=52dd15bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd15bb",
  null
  
)

export default component.exports